export const displaySidebarAlbums = visible => ({
  type: "DISPLAY_SIDEBAR_ALBUMS",
  visible
});
export const displaySignInModal = visible => ({
  type: "DISPLAY_SIGN_IN_MODAL",
  visible
});



// WEBPACK FOOTER //
// ./src/actions/actions/event.js